import { useMutation } from "react-query";

import { EmployeesReportIProps } from "~/entity/Ivideon/model/schema";
import { useNotify } from "~/shared/hooks/useNotify";

import { useIvideon } from "./useIvideon";

export const useGetEmployeesReport = (closeModal: () => void) => {
  const { getEmployeesReport } = useIvideon();
  const { notifyReport } = useNotify();

  const { data, isLoading, isError, mutate } = useMutation({
    mutationFn: (data: EmployeesReportIProps) => getEmployeesReport(data),
    onSuccess: (response) => {
      const hash = response?.data?.fileHash;
      if (hash) {
        notifyReport(hash);
        closeModal();
      }
    },
  });

  return {
    data: data?.data,
    isLoading: isLoading,
    isError: isError,
    getEmployeesDataReport: mutate,
  };
};
